// extracted by mini-css-extract-plugin
export var typingIndicator = "_r0-0";